import {Action, ActionReducerMap} from '@ngrx/store';
import {FunkprotokollEintrag, FunkprotokollFall, FunkprotokollVorlageDetail, Meldeart, Veranstaltung} from '../../../clients/veranstaltungen';
import * as actionsUi from './funkprotokollierung.actions.ui';
import * as _ from 'lodash';
import {
    GET_FUNKPROTOKOLL,
    GET_FUNKPROTOKOLL_ERFOLGREICH,
    GET_FUNKPROTOKOLL_FEHLER, GET_FUNKPROTOKOLL_MELDEART_LISTE, GET_FUNKPROTOKOLL_MELDEART_LISTE_ERFOLGREICH, GET_FUNKPROTOKOLL_MELDEART_LISTE_FEHLER, GET_FUNKPROTOKOLL_VORLAGEN_LISTE, GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ERFOLGREICH, GET_FUNKPROTOKOLL_VORLAGEN_LISTE_FEHLER, GetFunkprotokollErfolgreichAction, GetFunkprotokollMeldeartListeErfolgreichAction, GetFunkprotokollVorlagenListeErfolgreichAction,
    POST_FUNKPROTOKOLL_EINTRAG_ENTFERNEN_ERFOLGREICH,
    POST_FUNKPROTOKOLL_EINTRAG_ERFASSEN_ERFOLGREICH,
    POST_FUNKPROTOKOLL_FALL_ABSCHLIESSEN_ERFOLGREICH, POST_FUNKPROTOKOLL_FALL_ENTFERNEN_ERFOLGREICH,
    POST_FUNKPROTOKOLL_FALL_ERFASSEN_ERFOLGREICH,
    POST_FUNKPROTOKOLL_FALL_REAKTIVIEREN_ERFOLGREICH,
    PostFunkprotokollEintragEntfernenErfolgreichAction,
    PostFunkprotokollEintragErfassenErfolgreichAction, PostFunkprotokollFallEntfernenErfolgreichAction,
    PostFunkprotokollFallErfassenErfolgreichAction
} from '../../../client-ngrx/veranstaltungen';
import {GET_INCIDENT_BY_FUNKPROTOKOLL_FALL, GET_INCIDENT_BY_FUNKPROTOKOLL_FALL_ERFOLGREICH, GET_INCIDENT_BY_FUNKPROTOKOLL_FALL_FEHLER, GetIncidentByFunkprotokollFallErfolgreichAction} from '../../../client-ngrx/incidents';
import {IncidentKopf} from '../../../clients/incidents';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    veranstaltungenAktuellLaden: boolean;
    veranstaltungenAktuellFehler: boolean;
    veranstaltungenAktuell: Array<Veranstaltung>;

    meldearten: Array<Meldeart>;
    meldeartenLaden: boolean;
    meldeartenFehler: boolean;

    veranstaltungenBeendetLaden: boolean;
    veranstaltungenBeendetFehler: boolean;
    veranstaltungenBeendet: Array<Veranstaltung>;

    aktuelleVeranstaltung: Veranstaltung;

    listeProtokollFaelleLaden: boolean;
    listeProtokollFaelleFehler: boolean;
    listeProtokollFaelle: Array<FunkprotokollFall>;

    aktuellerProtokollFall: FunkprotokollFall;

    incident: IncidentKopf;
    incidentLaden: boolean;
    incidentFehler: boolean;

    funkVorlagenListe: Array<FunkprotokollVorlageDetail>;
    funkVorlagenListeLaden: boolean;
    funkVorlagenListeFehler: boolean;

    aktuellerProtokollEintrag: FunkprotokollEintrag;
}

export const initialPageState: PageState = {
    veranstaltungenAktuellLaden: false,
    veranstaltungenAktuellFehler: false,
    veranstaltungenAktuell: [],

    meldearten: [],
    meldeartenLaden: false,
    meldeartenFehler: false,

    veranstaltungenBeendetLaden: false,
    veranstaltungenBeendetFehler: false,
    veranstaltungenBeendet: [],

    aktuelleVeranstaltung: null,

    listeProtokollFaelleLaden: false,
    listeProtokollFaelleFehler: false,
    listeProtokollFaelle: [],

    aktuellerProtokollFall: null,

    incident: null,
    incidentLaden: false,
    incidentFehler: false,

    funkVorlagenListe: [],
    funkVorlagenListeLaden: false,
    funkVorlagenListeFehler: false,

    aktuellerProtokollEintrag: null
};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        case actionsUi.AUSWAHL_AUFHEBEN: {
            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: null,
                aktuellerProtokollEintrag: null
            });
        }

        // Funkprotokoll laden
        case GET_FUNKPROTOKOLL: {
            return Object.assign({}, state, <PageState> {
                listeProtokollFaelleLaden: true,
                listeProtokollFaelleFehler: false
            });
        }

        case GET_FUNKPROTOKOLL_ERFOLGREICH: {
            const a = <GetFunkprotokollErfolgreichAction> action;

            let faelle: Array<FunkprotokollFall> = [];
            let aktuellerFall = [];
            let aktuellerEintrag = [];

            if (a.payload !== null && a.payload !== undefined) {
                if (a.payload.faelle !== null && a.payload.faelle !== undefined && a.payload.faelle.length > 0) {
                    // faelle = Object.assign(a.payload.faelle);
                    faelle = a.payload.faelle;
                    aktuellerFall = faelle.filter((x) => state.aktuellerProtokollFall !== null && x.fall_id === state.aktuellerProtokollFall.fall_id);
                    if (aktuellerFall.length === 1) {
                        aktuellerEintrag = aktuellerFall[0].eintraege.filter((x) => state.aktuellerProtokollEintrag !== null && x.eintrag_id === state.aktuellerProtokollEintrag.eintrag_id);
                    }
                    // faelle = Object.assign(a.payload.faelle).filter(
                    //     x => x.ist_abgeschlossen === false
                    // );
                }
            }

            return Object.assign({}, state, <PageState> {
                listeProtokollFaelleLaden: false,
                listeProtokollFaelleFehler: false,
                listeProtokollFaelle: faelle,
                aktuellerProtokollFall: aktuellerFall.length === 1 ? aktuellerFall[0] : state.aktuellerProtokollFall,
                aktuellerProtokollEintrag: aktuellerEintrag.length === 1 ? aktuellerEintrag[0] : state.aktuellerProtokollEintrag
            });
        }

        case GET_FUNKPROTOKOLL_FEHLER: {
            return Object.assign({}, state, <PageState> {
                listeProtokollFaelleLaden: false,
                listeProtokollFaelleFehler: true,
                listeProtokollFaelle: [],
                aktuellerProtokollFall: null,
                aktuellerProtokollEintrag: null
            });
        }

        // Meldearten laden
        case GET_FUNKPROTOKOLL_MELDEART_LISTE: {
            return Object.assign({}, state, <PageState> {
                meldeartenLaden: true,
                meldeartenFehler: false
            });
        }

        case GET_FUNKPROTOKOLL_MELDEART_LISTE_ERFOLGREICH: {
            const a = <GetFunkprotokollMeldeartListeErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                meldeartenLaden: false,
                meldeartenFehler: false,
                meldearten: a.payload
            });
        }

        case GET_FUNKPROTOKOLL_MELDEART_LISTE_FEHLER: {
            return Object.assign({}, state, <PageState> {
                meldeartenLaden: false,
                meldeartenFehler: true,
                meldearten: []
            });
        }

        // Incident zu Funkprotokoll laden
        case GET_INCIDENT_BY_FUNKPROTOKOLL_FALL: {
            return Object.assign({}, state, <PageState> {
                incidentLaden: true,
                incidentFehler: false
            });
        }

        case GET_INCIDENT_BY_FUNKPROTOKOLL_FALL_ERFOLGREICH: {
            const a = <GetIncidentByFunkprotokollFallErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                incidentLaden: false,
                incidentFehler: false,
                incident: a.payload
            });
        }

        case GET_INCIDENT_BY_FUNKPROTOKOLL_FALL_FEHLER: {
            return Object.assign({}, state, <PageState> {
                incidentLaden: false,
                incidentFehler: true,
                incident: null
            });
        }

        case actionsUi.VERANSTALTUNGEN_AUSGEWAEHLT: {
            const a = <actionsUi.VeranstaltungAusgewaehlt> action;

            return Object.assign({}, state, <PageState> {
                aktuelleVeranstaltung: a.payload,
                aktuellerProtokollFall: null,
                aktuellerProtokollEintrag: null
            });
        }

        case actionsUi.NEUER_PROTOKOLL_FALL: {
            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: {
                    titel: '',
                    erinnerung_zeitpunkt_utc: new Date(),
                    erinnerung_in_minuten: 30,
                    eintraege: [],
                    ist_abgeschlossen: false,
                }
            });
        }

        case actionsUi.NEUER_PROTOKOLL_EINTRAG: {
            return Object.assign({}, state, <PageState> {
                aktuellerProtokollEintrag: {
                    melder: '',
                    text: '',
                    melde_zeitpunkt_utc: new Date(),
                    meldeart_text: null,
                    meldeart_id: null
                }
            });
        }

        case actionsUi.PROTOKOLL_FALL_AUSGEWAEHLT: {
            const a = <actionsUi.ProtokollFallAusgewaehlt> action;

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: a.payload,
                aktuellerProtokollEintrag: null
            });
        }

        case actionsUi.PROTOKOLL_EINTRAG_AUSGEWAEHLT: {
            const a = <actionsUi.ProtokollEintragAusgewaehlt> action;

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollEintrag: a.payload,
                incident: null
            });
        }

        case actionsUi.PROTOKOLL_FALL_EINGABE: {
            const a = <actionsUi.ProtokollFallEingabe> action;

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: a.payload
            });
        }

        case actionsUi.PROTOKOLL_FALL_EINGABE_TITEL_MELDUNG: {
            const a = <actionsUi.ProtokollFallEingabeTitelMeldung> action;

            const fall = Object.assign({}, state.aktuellerProtokollFall, {
                titel: a.payload.titel
            });
            const eintrag = Object.assign({}, state.aktuellerProtokollEintrag, {
                text: a.payload.meldung
            });

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: fall,
                aktuellerProtokollEintrag: eintrag
            });
        }

        case actionsUi.PROTOKOLL_EINTRAG_EINGABE: {
            const a = <actionsUi.ProtokollEintragEingabe> action;

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollEintrag: a.payload
            });
        }

        case POST_FUNKPROTOKOLL_FALL_ERFASSEN_ERFOLGREICH: {
            const a = <PostFunkprotokollFallErfassenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: (!a.optPayload.neuerFall) ? <FunkprotokollFall>Object.assign({}, state.aktuellerProtokollFall, a.funkprotokollFallRequest) : <FunkprotokollFall>{
                    fall_id: null,
                    titel: '',
                    erinnerung_zeitpunkt_utc: new Date,
                    ist_abgeschlossen: false,
                    eintraege: [],
                    letzter_eintrag_id: null,
                    erinnerung_in_minuten: 30
                    },
                aktuellerProtokollEintrag: (!a.optPayload.neuerEintrag) ? <FunkprotokollEintrag>Object.assign({}, state.aktuellerProtokollEintrag) : <FunkprotokollEintrag>{
                    fall_id: null,
                    text: '',
                    melder: '',
                    melde_zeitpunkt_utc: new Date,
                    meldeart_id: null,
                    meldeart_text: null,
                    eintrag_id: null
                }
            });
        }

        case POST_FUNKPROTOKOLL_EINTRAG_ERFASSEN_ERFOLGREICH: {
            const a = <PostFunkprotokollEintragErfassenErfolgreichAction> action;
            const eintraege = _.toArray(Object.assign({}, state.aktuellerProtokollFall.eintraege));
            const eintrag = eintraege.find((item) => item.eintrag_id === a.funkprotokollEintragRequest.eintrag_id);
            const index = eintraege.indexOf(eintrag, 0);
            let aktuellerFall = null;
            if (!a.optPayload.neuerFall) {
                if (eintrag === undefined) {
                    // eintraege.push(a.funkprotokollEintragRequest);
                    eintraege.splice(0, 0, a.funkprotokollEintragRequest);
                } else {
                    eintraege.splice(index, 1, a.funkprotokollEintragRequest);
                }
                aktuellerFall = Object.assign({}, state.aktuellerProtokollFall, {eintraege: eintraege});
            }

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: (!a.optPayload.neuerFall) ? aktuellerFall : state.aktuellerProtokollFall,
                aktuellerProtokollEintrag: (!a.optPayload.neuerEintrag) ? <FunkprotokollEintrag>Object.assign({}, state.aktuellerProtokollEintrag, a.funkprotokollEintragRequest) : <FunkprotokollEintrag>{
                    fall_id: null,
                    text: '',
                    melder: '',
                    melde_zeitpunkt_utc: new Date,
                    meldeart_id: null,
                    meldeart_text: null,
                    eintrag_id: null
                }
            });
        }

        case POST_FUNKPROTOKOLL_FALL_ENTFERNEN_ERFOLGREICH: {
            const a = <PostFunkprotokollFallEntfernenErfolgreichAction> action;
            let eintraege = _.toArray(Object.assign({}, state.aktuellerProtokollFall.eintraege));
            eintraege = [];

            const aktuellerFall = Object.assign({}, state.aktuellerProtokollFall, {eintraege: eintraege});

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: null,
                aktuellerProtokollEintrag: null
            });
        }

        case POST_FUNKPROTOKOLL_EINTRAG_ENTFERNEN_ERFOLGREICH: {
            const a = <PostFunkprotokollEintragEntfernenErfolgreichAction> action;
            const eintraege = _.toArray(Object.assign({}, state.aktuellerProtokollFall.eintraege));
            const eintrag = eintraege.find((item) => item.eintrag_id === a.funkprotokollEintragRequest.eintrag_id);
            const index = eintraege.indexOf(eintrag, 0);
            if (eintrag !== undefined) {
                eintraege.splice(index, 1);
            }

            const aktuellerFall = Object.assign({}, state.aktuellerProtokollFall, {eintraege: eintraege});

            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: aktuellerFall,
                aktuellerProtokollEintrag: null
            });
        }

        case POST_FUNKPROTOKOLL_FALL_ABSCHLIESSEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: null,
                aktuellerProtokollEintrag: null
            });
        }

        case POST_FUNKPROTOKOLL_FALL_REAKTIVIEREN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState> {
                aktuellerProtokollFall: null,
                aktuellerProtokollEintrag: null
            });
        }

        // Funkprotokoll Vorlagen laden
        case GET_FUNKPROTOKOLL_VORLAGEN_LISTE: {
            return Object.assign({}, state, <PageState> {
                funkVorlagenListeLaden: true,
                funkVorlagenListeFehler: false
            });
        }

        case GET_FUNKPROTOKOLL_VORLAGEN_LISTE_ERFOLGREICH: {
            const a = <GetFunkprotokollVorlagenListeErfolgreichAction>action;

            return Object.assign({}, state, <PageState> {
                funkVorlagenListeLaden: false,
                funkVorlagenListeFehler: false,
                funkVorlagenListe: a.payload
            });
        }

        case GET_FUNKPROTOKOLL_VORLAGEN_LISTE_FEHLER: {
            return Object.assign({}, state, <PageState> {
                funkVorlagenListeLaden: false,
                funkVorlagenListeFehler: true,
                funkVorlagenListe: []
            });
        }

        default: {
            return state;
        }
    }
}
